import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('setBlockedDomainsOption')(function setBlockedDomainsOption(blockedSenders, state) {
    var optionState = state.optionState;
    optionState.blockedDomains = blockedSenders;
}));
//# sourceMappingURL=setBlockedDomainsOption.js.map